<div class=" d-none d-sm-block">

<div class="about-page">
<nav class="navbar navbar-expand-lg fixed-top navbar-dark bg-dark">
  <div class="container-fluid">
    <a class="navbar-brand text-white" href="#">COSMO SPORTS</a>
    <button class="navbar-toggler" type="button" (click)="isCollapsed = !isCollapsed">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div [ngClass]="{'collapse navbar-collapse justify-content-end': true, 'show': !isCollapsed}" id="navbarNavDropdown">
      <ul class="navbar-nav">
        <li class="nav-item">
          <a routerLink="/home-page" class="nav-link text-white" routerLinkActive="active">Home</a>
        </li>
        <li class="nav-item">
          <a routerLink="/about-us" class="nav-link text-white" routerLinkActive="active">About Us</a>
        </li>
        <li class="nav-item">
          <a routerLink="/contact-us" class="nav-link text-white" routerLinkActive="active">Contact</a>
        </li>
      </ul>
    </div>
  </div>
</nav>

<section class="aboutus-section">
  <div class="aboutus-text">
    <h1>Welcome to <span>COSMO SPORTS</span></h1>
    <p>
      At <strong>COSMO SPORTS</strong>, we believe that every athlete deserves the best. 
      From cricket bats to gym gear, from running shoes to footballs — 
      we bring you premium-quality sports equipment to help you perform at your peak.
    </p>
    <p>
      Our mission is to inspire passion, performance, and perseverance in every player. 
      Step in, gear up, and conquer your goals with us!
    </p>
    <a routerLink="/contact-us" class="aboutus-btn" style="text-align: center;">Explore More</a>
  </div>

  <div class="aboutus-image">
    <img src="assets/img/home/about-us.jpg" alt="Sports Shop" />
  </div>
</section>



<section class="services-section">
  <div class="services-content">
    <h2>Our Services</h2>
    <p>
      We provide top-quality customization and sports event essentials for 
      <strong>schools, colleges, and competitions</strong>.
    </p>
    <ul>
      <li>🏆 Shields & Mementos</li>
      <li>🎖️ Custom Name Stickers</li>
      <li>👕 T-Shirt Name & Logo Printing</li>
    </ul>
    <p>
      At <strong>COSMO SPORTS</strong>, we make every event memorable with precision, creativity, and quality.
    </p>
    <a routerLink="/contact-us" class="nav-link text-white" routerLinkActive="active" class="services-btn">Contact Us</a>
  </div>
</section>

  <section class="shop-features-section">
  <h2>Why Choose Our Sports Shop</h2>
  <div class="feature-cards">
    <div class="feature-card">
      <h4>Wide Variety</h4>
      <p>We offer sports gear for all ages and disciplines, from children to professional athletes.</p>
    </div>
    <div class="feature-card">
      <h4>Premium Quality</h4>
      <p>All our products are sourced from trusted brands to ensure durability and top performance.</p>
    </div>
    <div class="feature-card">
      <h4>Affordable Prices</h4>
      <p>We provide the best prices in the market so you can get quality sports gear without overspending.</p>
    </div>
  </div>
</section>


<section class="cta-section">
  <h2>Ready to Elevate Your Game?</h2>
  <p>Explore our range of products and discover how COSMO SPORTS can help you achieve your goals.</p>
  <a routerLink="/contact-us" class="cta-btn">Contact Our Team <i class="fa fa-arrow-right"></i></a>
</section>


  <section class="contact-section">
    <a href="tel:8056529291" class="contact-btn"><i class="fa fa-phone"></i> Call Now</a>
    <a href="mailto:Cosmosports51@gmail.com" class="contact-btn"><i class="fa fa-envelope"></i> Email Us</a>
    <a href="https://wa.me/8056529291" target="_blank" class="contact-btn"><i class="fa fa-whatsapp"></i> WhatsApp</a>
    <a href="https://www.instagram.com/cosmo_sports_51" target="_blank" class="contact-btn instagram-btn"><i class="fa fa-instagram"></i> Instagram</a>
  </section>

<footer class="bg-dark text-white pt-5 pb-3 mt-auto">
  <div class="container">
    <div class="row text-center text-md-start">

      <div class="col-md-4 mb-4 mb-md-0 text-center text-md-start">
        <img src="../../assets/img/home/cosmologo.jpg" alt="Sports Shop Logo" width="80" class="mb-3">
        <h5 class="fw-bold">Gear Up for Your Game!</h5>
        <p class="small">High-quality sports equipment and apparel for every athlete.</p>
      </div>

 
      <div class="col-md-4 mb-4 mb-md-0">
        <h5 class="fw-bold">Quick Links</h5>
        <ul class="list-unstyled">
          <li><a routerLink="/" class="text-white text-decoration-none">Home</a></li>
          <li><a routerLink="/about-us" class="text-white text-decoration-none">About Us</a></li>
          <li><a routerLink="/contact-us" class="text-white text-decoration-none">Contact Us</a></li>
        </ul>
      </div>

      <div class="col-md-4">
        <h5 class="fw-bold">Contact Info</h5>
        <p class="mb-1">ECR ROUNDANA, East Coast Rd, Puthur, Manjakollai, Nagapattinam, Tamil Nadu 611106</p>
        <p class="mb-1">Phone: <a href="tel:+9500706718" class="text-white text-decoration-none">+91 9500706718</a></p>
        <p>Email: <a href="mailto:Cosmosports51@gmail.com" class="text-white text-decoration-none">Cosmosports51@gmail.com</a></p>
      </div>

    </div>

    <hr class="bg-secondary my-4">
    <div class="text-center">
      <p class="mb-1">&copy; 2025 Sports Shop. All rights reserved.</p>
      <p class="mb-0" style="font-size: 12px;">
        Designed by <a href="http://annaasilicontechnology.com/#/" target="_blank" class="text-white text-decoration-none">Annaa Silicon Technology Pvt. Ltd.</a>
      </p>
    </div>
  </div>
</footer>

</div>

</div>






<!-- ---------------------------------MOBILE VIEW------------------------------------ -->
<div class=" d-block d-sm-none">


<nav class="navbar navbar-expand-lg fixed-top navbar-dark bg-dark">
  <div class="container-fluid">
    <a class="navbar-brand text-white" href="#">COSMO SPORTS</a>
    <button class="navbar-toggler" type="button" (click)="isCollapsed = !isCollapsed">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div [ngClass]="{'collapse navbar-collapse justify-content-end': true, 'show': !isCollapsed}" id="navbarNavDropdown">
      <ul class="navbar-nav">
        <li class="nav-item">
          <a routerLink="/home-page" class="nav-link text-white" routerLinkActive="active">Home</a>
        </li>
        <li class="nav-item">
          <a routerLink="/about-us" class="nav-link text-white" routerLinkActive="active">About Us</a>
        </li>
        <li class="nav-item">
          <a routerLink="/contact-us" class="nav-link text-white" routerLinkActive="active">Contact</a>
        </li>
      </ul>
    </div>
  </div>
</nav>

<section class="aboutus-section">
  <div class="aboutus-text">
    <h1>Welcome to <span>COSMO SPORTS</span></h1>
    <p>
      At <strong>COSMO SPORTS</strong>, we believe that every athlete deserves the best. 
      From cricket bats to gym gear, from running shoes to footballs — 
      we bring you premium-quality sports equipment to help you perform at your peak.
    </p>
    <p>
      Our mission is to inspire passion, performance, and perseverance in every player. 
      Step in, gear up, and conquer your goals with us!
    </p>
    <a routerLink="/contact-us" class="aboutus-btn" style="text-align: center;">Explore More</a>
  </div>

  <!-- <div class="aboutus-image">
    <img src="assets/img/home/about-us.jpg" alt="Sports Shop" />
  </div> -->
</section>



<section class="services-section">
  <div class="services-content">
    <h2>Our Services</h2>
    <p>
      We provide top-quality customization and sports event essentials for 
      <strong>schools, colleges, and competitions</strong>.
    </p>
    <ul>
      <li>🏆 Shields & Mementos</li>
      <li>🎖️ Custom Name Stickers</li>
      <li>👕 T-Shirt Name & Logo Printing</li>
    </ul>
    <p>
      At <strong>COSMO SPORTS</strong>, we make every event memorable with precision, creativity, and quality.
    </p>
    <a href="" routerLink="/contact-us" routerLinkActive="active">Contact Us</a>
  </div>
</section>

  <section class="shop-features-section">
  <h2>Why Choose Our Sports Shop</h2>
  <div class="feature-cards">
    <div class="feature-card">
      <h4>Wide Variety</h4>
      <p>We offer sports gear for all ages and disciplines, from children to professional athletes.</p>
    </div>
    <div class="feature-card">
      <h4>Premium Quality</h4>
      <p>All our products are sourced from trusted brands to ensure durability and top performance.</p>
    </div>
    <div class="feature-card">
      <h4>Affordable Prices</h4>
      <p>We provide the best prices in the market so you can get quality sports gear without overspending.</p>
    </div>
  </div>
</section>

<section class="cta-section">
  <h2>Ready to Elevate Your Game?</h2>
  <p>Explore our range of products and discover how COSMO SPORTS can help you achieve your goals.</p>
  <a routerLink="/contact-us" class="cta-btn">Follow Us</a>
</section>


 
  <section class="contact-section">
    <a href="tel:8056529291" class="contact-btn"><i class="fa fa-phone"></i> Call Now</a>
    <a href="mailto:info@cosmosports.com" class="contact-btn"><i class="fa fa-envelope"></i> Email Us</a>
    <a href="https://wa.me/8056529291" target="_blank" class="contact-btn"><i class="fa fa-whatsapp"></i> WhatsApp</a>
     <a href="https://www.instagram.com/cosmo_sports_51" target="_blank" class="contact-btn instagram-btn"><i class="fa fa-instagram"></i> Instagram</a>
  </section>
  <div style="flex: 1; height: 2px; background: #ddd; margin: 0 10px; position: relative;">
    <i class="fa fa-rocket" style="position: absolute; top: -12px; left: 50%; transform: translateX(-50%); background: #fff;
   padding: 5px; color: #7d7d7d; border-radius: 50%;"></i>
  </div>

<footer class="bg-dark text-white pt-5 pb-3 mt-auto">
  <div class="container">
    <div class="row text-center text-md-start">

      <div class="col-md-4 mb-4 mb-md-0 text-center text-md-start">
        <img src="../../assets/img/home/cosmologo.jpg" alt="Sports Shop Logo" width="80" class="mb-3">
        <h5 class="fw-bold">Gear Up for Your Game!</h5>
        <p class="small">High-quality sports equipment and apparel for every athlete.</p>
      </div>

 
      <div class="col-md-4 mb-4 mb-md-0">
        <h5 class="fw-bold">Quick Links</h5>
        <ul class="list-unstyled">
          <li><a routerLink="/" class="text-white text-decoration-none">Home</a></li>
          <li><a routerLink="/about-us" class="text-white text-decoration-none">About Us</a></li>
          <li><a routerLink="/contact-us" class="text-white text-decoration-none">Contact Us</a></li>
        </ul>
      </div>

      <div class="col-md-4">
        <h5 class="fw-bold">Contact Info</h5>
        <p class="mb-1">ECR ROUNDANA, East Coast Rd, Puthur, Manjakollai, Nagapattinam, Tamil Nadu 611106</p>
        <p class="mb-1">Phone: <a href="tel:+919500706718" class="text-white text-decoration-none">+91 9500706718</a></p>
        <p>Email: <a href="mailto:info@sportsshop.com" class="text-white text-decoration-none">info@sportsshop.com</a></p>
      </div>

    </div>

    <hr class="bg-secondary my-4">
    <div class="text-center">
      <p class="mb-1">&copy; 2025 Sports Shop. All rights reserved.</p>
      <p class="mb-0" style="font-size: 12px;">
        Designed by <a href="http://annaasilicontechnology.com/#/" target="_blank" class="text-white text-decoration-none">Annaa Silicon Technology Pvt. Ltd.</a>
      </p>
    </div>
  </div>
</footer>
</div>